exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-pagination[data-v-75801b2e] {\n  padding: 10px;\n  float: right;\n}\n.am-office-messages-th[data-v-75801b2e] {\n  cursor: pointer;\n}\n", ""]);

// exports
